<h3 class="goodbye">{{'SigningOut'|translate}}...</h3>
